import { type StateCreator } from 'zustand';

export type WorkspaceIdVisibleSlice = {
  workspaceIdVisible: boolean;
  setWorkspaceIdVisible: (workspaceIdVisible: boolean) => void;
  toggleWorkspaceIdVisible: () => void;
};

type CreateWorkspaceIdVisibleSlice = (
  initialState: Pick<WorkspaceIdVisibleSlice, 'workspaceIdVisible'>,
) => StateCreator<WorkspaceIdVisibleSlice, [], [], WorkspaceIdVisibleSlice>;

export const createWorkspaceIdVisibleSlice: CreateWorkspaceIdVisibleSlice = (initialState) => (set) => ({
  workspaceIdVisible: initialState.workspaceIdVisible ?? false,
  setWorkspaceIdVisible: (workspaceIdVisible: boolean) => set({ workspaceIdVisible }),
  toggleWorkspaceIdVisible: () => set((state) => ({ workspaceIdVisible: !state.workspaceIdVisible })),
});
